import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { IProps } from './SpecialBanner.types';

export const openSpecialBanner = (data: IProps) => openPopupHelper({ popupName: popupNames.SPECIAL_BANNER, data });